import React from 'react'
import NextImage from '../images/NextImage'
import Styling from '../../styling'


export default function Avatar(props) {
  const {
    imageURL,
    imageAlt,
    imageWidth=128,
    imageHeight,
    imageContainerWidthClass="w-12",
    imageContainerHeightClass="h-12",
    className="",
    username="",
    description="",
    rounded=true,
    isSideBar=false,
    authorNotCenteredInMobile=false,
  } = props
  const roundedClasses = rounded ? 'rounded-full' : ''

  const sideBarClasses = 'flex-col text-center md:flex-row md:text-left'
  const defaultClasses = 'flex-col text-center md:flex-row md:text-left'
  const authorNotCenteredInMobileClasses = 'flex-row text-left'

  let layoutClasses = ''
  
  if(isSideBar) {
    layoutClasses += ` ${sideBarClasses}`
  } else if(authorNotCenteredInMobile) {
    layoutClasses += ` ${authorNotCenteredInMobileClasses}`
  } else {
    layoutClasses += ` ${defaultClasses}`
  }


  return (
    <div className={`${className} flex gap-4 ${layoutClasses}`}>
      <div className={`${imageContainerWidthClass} ${imageContainerHeightClass} shrink mx-auto ${isSideBar ? '': 'md:mx-0'} overflow-hidden`}>
        <NextImage 
          src={imageURL} 
          className={`${roundedClasses} `} 
          alt={imageAlt} 
          width={imageWidth} 
          height={imageHeight} 
          style={{objectFit: 'contain'}}
          addPadding={true}
        />
      </div>
      <div className="grow">
        <p className={`${Styling.sizes.sm.strong}`}>{username}</p>
        <p className={`${Styling.sizes.xs.default} flex-1 text-smoke-700`}>{description}</p>
      </div>
    </div>
  )
}
